// extracted by mini-css-extract-plugin
export default {"rotateDiv":"styles_rotateDiv__LbIpg","rotate":"styles_rotate__KrUio","rotation":"styles_rotation__vc5BM","arrow":"styles_arrow__Wa3Wj"};